<template>
  <v-dialog v-model="show" max-width="480" persistent>
    <v-card>
      <v-card-title>{{ entry ? $t("finance_edit_item_title") : $t("finance_add_item") }}</v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-form ref="form" v-model="valid">
          <text-field
            v-model="form.orderRef"
            :label="$t('finance_order_ref_label')"
            prepend-inner-icon="mdi-pound"
            :rules="[rules.required]"
          />
          <date-picker
            v-model="form.date"
            :label="$t('finance_date')"
            single-date
            :rules="[rules.required]"
          />
          <text-field
            v-model.number="form.turnover"
            :label="$t('finance_turnover_currency', { currency: restaurantCurrency })"
            type="number"
            step="0.01"
            kind="money"
            :rules="[rules.required, rules.positive]"
          />
          <text-field
            v-model.number="form.rate"
            :label="$t('finance_commission_rate')"
            type="number"
            step="0.1"
            prepend-inner-icon="mdi-percent-outline"
            :rules="[rules.required, rules.range0to100]"
          />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="saving" @click="close">{{ $t("finance_cancel") }}</v-btn>
        <primary-button :loading="saving" @click="submit">{{ $t("finance_save") }}</primary-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CommissionFormDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    entry: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      valid: true,
      form: {
        orderRef: "",
        date: "",
        turnover: 0,
        rate: 0,
      },
      rules: {
        required: (v) => (v !== null && v !== undefined && v !== "") || this.$t("finance_required_field"),
        positive: (v) => Number(v) > 0 || this.$t("finance_value_must_be_positive"),
        range0to100: (v) => (Number(v) >= 0 && Number(v) <= 100) || this.$t("finance_value_range_0_100"),
      },
    };
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    value(isOpen) {
      if (!isOpen) return;
      this.resetForm();
    },
  },

  methods: {
    resetForm() {
      if (this.entry) {
        this.form = {
          orderRef: this.entry.orderRef,
          date: (this.entry.date || "").slice(0, 10),
          turnover: this.entry.turnover,
          rate: this.entry.rate,
        };
      } else {
        this.form = { orderRef: "", date: "", turnover: 0, rate: 0 };
      }
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
    },

    close() {
      this.$emit("close");
      this.show = false;
    },

    submit() {
      if (this.$refs.form && !this.$refs.form.validate()) return;

      this.$emit("save", {
        order_ref: this.form.orderRef,
        date: this.form.date,
        turnover: Number(this.form.turnover),
        rate: Number(this.form.rate),
      });
    },
  },
};
</script>
